import dynamicfunction from '../utils/dynamicfunction';
import { ReactSVG } from 'react-svg';
import Loader from './Loader';
import { textSizes } from '../config/config';
import { useSelector } from 'react-redux';
import { useWindowWidth } from '../utils/helpers';
import { cn } from '../utils/utils';

const Button = ({
  text,
  bgColor = 'bg-orange',
  weight,
  color = 'text-white',
  className,
  onClick,
  textSize,
  isDisabled = false,
  icon,
  iconClassName = '',
  type,
  loading,
  loaderColor,
}) => {
  const { TextWeight } = dynamicfunction();
  const fontsize = useSelector((state) => state.content?.fontsize);
  const width = useWindowWidth();

  const getSize = () => {
    if (fontsize === textSizes.small) {
      return textSize ? Number(textSize) - 2 : width > 640 ? 10 : 7;
    } else if (fontsize === textSizes.medium) {
      return textSize ? Number(textSize) : width > 640 ? 12 : 9;
    } else if (fontsize === textSizes.large) {
      return textSize ? Number(textSize) + 2 : width > 640 ? 14 : 12;
    }
  };

  return (
    <button
      style={{
        fontSize: getSize(),
      }}
      type={type}
      className={cn(
        'py-2 flex justify-center min-h-[2.2rem] items-center gap-2 px-0 rounded uppercase',
        weight ? weight : TextWeight.regular,
        className,
        isDisabled ? 'bg-grey text-white border-grey' : `${bgColor} ${color}`,
      )}
      onClick={isDisabled ? null : onClick}
      disabled={isDisabled || loading}
    >
      {loading ? (
        <Loader color={loaderColor ? loaderColor : 'border-t-white'} width={'w-4'} height={'h-4'} className={'border-t-2'} />
      ) : (
        <>
          {icon && <ReactSVG src={icon} className={iconClassName} />}
          {text}
        </>
      )}
    </button>
  );
};

export default Button;
